module.exports = __webpack_public_path__ + "static/media/sorry.5fa82727.svg";